import React from "react";
import CouponRedemptionMock from "./CouponRedemptionMock";
import CollapsibleSection from "./CouponDesigner/CollapsibleSection";
import ColorInput from "./CouponDesigner/ColorInput";
import useCouponConfig from "./CouponDesigner/useCouponConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ColorCollapsibleSection from "./CouponDesigner/ColorCollapsibleSection";

function CouponDesigner() {
  const { config, handleChange, handleToggle, hasPreview } = useCouponConfig();

  const expired = new Date(config.endDate) < new Date();
  const isCreatingNew = expired || !hasPreview;

  const handleSubmit = async () => {
    const {
      thank_you_title,
      thank_you_subtitle,
      note,
      show_qr_code,
      background_color,
      text_color,
      title_color,
      title_size,
      subtitle_color,
      subtitle_size,
      discount_color,
      discount_size,
      note_color,
      note_size,
      code_text_color,
      code_bg_color,
      code_border_color,
      code_border_style,
      cover_image = "",
    } = config;

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    const stylingData = {
      thank_you_title,
      thank_you_subtitle,
      note,
      show_qr_code,
      cover_image,
      background_color,
      text_color,
      title_color,
      title_size,
      subtitle_color,
      subtitle_size,
      discount_color,
      discount_size,
      note_color,
      note_size,
      code_text_color,
      code_bg_color,
      code_border_color,
      code_border_style,
    };

    try {
      const styleResponse = await fetch(
        hasPreview
          ? "https://zola.technology/api/company/coupon-page/update/"
          : "https://zola.technology/api/company/coupon-page/create/",
        {
          method: isCreatingNew ? "POST" : "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(stylingData),
        }
      );

      if (!styleResponse.ok) {
        throw new Error("Styling save failed");
      }

      toast.success(
        isCreatingNew ? "New coupon styling saved." : "Coupon styling updated."
      );
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while saving the coupon styling.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-6 p-6">
      <ToastContainer />
      {/* Left Side: Controls */}
      <div className="md:w-1/2 grid grid-cols-1 gap-4 bg-white p-4">
        <h2 className="text-2xl font-bold col-span-2">Customize Your Coupon</h2>

        <CollapsibleSection title="🎯 General Settings">
          {/* <div>
            <label className="block text-sm font-medium text-gray-700">
              Coupon Name
            </label>
            <input
              value={config.name}
              onChange={(e) => handleChange("name", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            />
          </div> */}

          <div className="grid col-span-2 gap-4 items-center">
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">
                Thank You Title
              </label>
              <input
                value={config.thank_you_title}
                onChange={(e) =>
                  handleChange("thank_you_title", e.target.value)
                }
                className="w-full border px-3 py-2 rounded-md"
              />
            </div>
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">
                Thank You Subtitle
              </label>
              <input
                value={config.thank_you_subtitle}
                onChange={(e) =>
                  handleChange("thank_you_subtitle", e.target.value)
                }
                className="w-full border px-3 py-2 rounded-md"
              />
            </div>
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">
              Note (Optional)
            </label>
            <input
              value={config.note}
              onChange={(e) => handleChange("note", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
              placeholder="Enter a short note..."
            />
          </div>

          {/* <div className="col-span-2 flex items-center justify-between">
            <label className="text-sm text-gray-700">Show Company Logo</label>
            <button
              onClick={() => handleToggle("show_logo")}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                config.show_logo ? "bg-blue-600" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                  config.show_logo ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div> */}
        </CollapsibleSection>

        {/* <CollapsibleSection title="💰 Discount Settings">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Discount Type
            </label>
            <select
              value={config.discount_type}
              onChange={(e) => handleChange("discount_type", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            >
              <option value="percentage">Percentage</option>
              <option value="fixed">Cash</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              {config.discount_type === "percentage"
                ? "Discount Percentage (%)"
                : "Cash Discount (USD)"}
            </label>
            <input
              type="number"
              value={config.discount_value}
              onChange={(e) =>
                handleChange("discount_value", parseInt(e.target.value, 10))
              }
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">
              Unique Code
            </label>
            <input
              value={config.unique_code}
              onChange={(e) => handleChange("unique_code", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>
        </CollapsibleSection> */}
        {/* <CollapsibleSection title="📍 Redemption Settings">
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">
              Redemption Area
            </label>
            <select
              value={config.redemption_area}
              onChange={(e) => handleChange("redemption_area", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            >
              <option value="" disabled>
                Select Redemption Area
              </option>
              <option value="feedback">Feedback</option>
              <option value="survey">Survey</option>
            </select>
          </div>
          <div className="col-span-2 flex items-center justify-between">
            <label className="text-sm text-gray-700">Show QR Code</label>
            <button
              onClick={() => handleToggle("show_qr_code")}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                config.show_qr_code ? "bg-blue-500" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                  config.show_qr_code ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        </CollapsibleSection> */}

        {/* <CollapsibleSection title="📅 Validity Period">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Start Date
            </label>
            <input
              type="date"
              value={config.startDate}
              min={new Date(Date.now() + 86400000).toISOString().split("T")[0]} // tomorrow
              onChange={(e) => handleChange("startDate", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              End Date
            </label>
            <input
              type="date"
              value={config.endDate}
              min={config.startDate}
              onChange={(e) => handleChange("endDate", e.target.value)}
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">
              Duration
            </label>
            <input
              type="text"
              value={config.duration}
              readOnly
              className="w-full border px-3 py-2 rounded-md bg-gray-100 text-gray-600 cursor-not-allowed"
            />
          </div>
        </CollapsibleSection> */}

        <ColorCollapsibleSection title="📝 Text Colors">
          <ColorInput
            label="Thank You Title Color"
            value={config.title_color}
            onChange={(val) => handleChange("title_color", val)}
          />
          <ColorInput
            label="Subtitle Color"
            value={config.subtitle_color}
            onChange={(val) => handleChange("subtitle_color", val)}
          />
          <ColorInput
            label="Discount Text Color"
            value={config.discount_color}
            onChange={(val) => handleChange("discount_color", val)}
          />
          <ColorInput
            label="Note Text Color"
            value={config.note_color}
            onChange={(val) => handleChange("note_color", val)}
          />
          <ColorInput
            label="Coupon Code Text Color"
            value={config.code_text_color}
            onChange={(val) => handleChange("code_text_color", val)}
          />
          {/* <ColorInput
            label="Validity Text Color"
            value={config.validity_color}
            onChange={(val) => handleChange("validity_color", val)}
          /> */}
        </ColorCollapsibleSection>

        <ColorCollapsibleSection title="🎨 Coupon Styling">
          <ColorInput
            label="Background Color"
            value={config.background_color}
            onChange={(val) => handleChange("background_color", val)}
          />
          <ColorInput
            label="Coupon Code Background"
            value={config.code_bg_color}
            onChange={(val) => handleChange("code_bg_color", val)}
          />
          <ColorInput
            label="Coupon Code Border Color"
            value={config.code_border_color}
            onChange={(val) => handleChange("code_border_color", val)}
          />
          <div>
            <label className="block text-sm font-medium">Border Style</label>
            <select
              value={config.code_border_style}
              onChange={(e) =>
                handleChange("code_border_style", e.target.value)
              }
              className="w-full border px-2 py-1 rounded"
            >
              <option value="dashed">Dashed</option>
              <option value="solid">Solid</option>
              <option value="dotted">Dotted</option>
              <option value="none">None</option>
            </select>
          </div>
        </ColorCollapsibleSection>
        <button
          onClick={handleSubmit}
          className="mt-4 col-span-2 bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition duration-300"
        >
          {hasPreview
            ? new Date(config.endDate) < new Date()
              ? "Create New Coupon"
              : "Edit Preview"
            : "Save Coupon"}
        </button>
      </div>

      {/* Right Side: Live Preview */}
      <div className="md:w-1/2 sticky top-6 self-start flex items-center justify-center">
        <CouponRedemptionMock previewData={config} />
      </div>
    </div>
  );
}

export default CouponDesigner;
